import { Link, useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import buildLink, { path } from "../urls";
import Loader from "./Loader";
import sq from "../assets/images/product_placeholder_square.png";
import { AccountContext } from "../contexts/AccountContext";
import axios from "axios";
import Cookies from "js-cookie";
import brandImage from "../assets/images/brand-svgrepo-com.svg";
import sellerImage from "../assets/images/shop-svgrepo-com.svg";
import { BsSearch } from "react-icons/bs";
import DOMPurify from "dompurify";
import { FaSearch } from "react-icons/fa"; // Import the search icon from react-icons

function TopSearch({ changeState }) {
  const history = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setResults([]);
    setViewResults(false);
    setShowSearch(false);
  }, [location]);
  const types = {
    1: "product",
    2: "category",
    3: "manufacturer",
    4: "seller",
  };
  const [results, setResults] = useState([]);
  const [viewResults, setViewResults] = useState(false);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [state] = useContext(AccountContext);
  const [overlay, setOverlay] = useState(false);
  const width = window.innerWidth;
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [message, setMessage] = useState();
  function setShowSearchFunction() {
    setShowSearch(false);
    setViewResults("");
  }
  function navigateSearch(e) {
    if (e.keyCode === 13) {
      const query = e.target.value;
      setQuery("");
      setLoading(false);
      history(
        `${
          window.location.href.indexOf("bey") < 0 ? "/search" : "/bey/search"
        }?keyword=${query}`,

        { state: location.pathname }
      );
    }
  }

  function handleOverlay(e) {
    if (e.keyCode === 13) {
      setOverlay(false);
    }
  }

  function handleSearchResults() {
    const input = document.getElementById("searchInput").value;
    if (input === "") {
      setViewResults(false);
      setLoading(false);
    } else {
      setViewResults(true);
    }
  }

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */

      if (overlay) {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setTimeout(() => setOverlay(false), 200);
            setTimeout(() => setViewResults(false), 200);
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
    }, [ref, overlay]);
  }

  useEffect(() => {
    // const source = axios.CancelToken.source();
    async function search() {
      setLoading(true);
      const res = await axios.get(
        buildLink("search", undefined, window.innerWidth) + query,
        {
          headers: {
            Authorization: "Bearer " + Cookies.get("api-token"),
          },
          // cancelToken: source.token,
        }
      );
      try {
        setResults(!res?.data?.message && res?.data?.data);
        setMessage(res?.data?.message);
        setLoading(false);
        setViewResults(true);
        setOverlay(true);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.error("axios error", error.message);
        } else {
          console.error(error);
        }
      }
    }
    if (query.length > 1) {
      search();
    } else {
      setLoading(false);
    }

    // return () => source.cancel("Previous request is canceled");
  }, [query]);

  return (
    <>
      {overlay && width > 1011 && (
        <div
          className="absolute z-50 w-full bg-dblackk opacity-50 min-h-screen min-w-full left-0 top-28"
          style={{ height: "1400px" }}
        ></div>
      )}
      <div className="relative xl:flex-grow  lg:flex-grow ">
        {/* mobile search */}
        {showSearch && (
          <div className="fixed top-0 left-0 bottom-0 right-0 bg-white z-50">
            <div className="flex px-3 border border-dgrey items-center">
              <i
                className="icon icon-angle-left text-2xl text-dgrey1"
                onClick={() => setShowSearchFunction()}
              ></i>
              <input
                value={query}
                onChange={(e) => {
                  const value = e.target.value;
                  const cleanedValue = value.replace(/\s{2,}/g, " ");
                  if (cleanedValue !== "" || value === "") {
                    setQuery(cleanedValue);
                  }
                }}
                onKeyDown={(e) => navigateSearch(e)}
                autoFocus
                className="block flex-grow mx-2 h-12 outline-none px-4 text-dblack"
                type="text"
                placeholder="What are you looking for? "
              />
              <i className="icon icon-search text-2xl text-dgrey1"></i>
            </div>
            {results?.length > 0 && viewResults ? (
              <div
                onMouseLeave={() => setViewResults(false)}
                className="text-dblack"
              >
                {results?.length > 0 &&
                  results
                    .slice(0, 8)
                    .map(({ type, id, value, img, num_prods }) => (
                      <Link
                        key={Math.random()}
                        className="px-4 py-2 cursor-pointer hover:bg-dgrey flex border-b-2 border-dgrey  capitalize text-d14"
                        to={
                          isNaN(type)
                           //? "search?keyword=" + value
                            ? `${path}/search?keyword=${value}`
                            :
                            //  state.admin
                            // ? `${path}/${types[type]}/${id}`
                            // : 
                            `${path}/${value
                                .replaceAll("/", "-").replaceAll("/", "-").replaceAll('%',parseInt("%"))
                                .replaceAll("%20", "-")}/${types[type]?.slice(
                                0,
                                1
                              )}=${id}`
                        }
                      >
                        <span className="flex w-full align-middle  h-auto my-2 px-1 ">
                          <span class="w-12 ">
                            {img.length > 0 ? (
                              <img
                                onError={(event) => (event.target.src = sq)}
                                width="24"
                                height="24"
                                src={`${img}`}
                                alt=""
                              />
                            ) : types[type] === "seller" ||
                              types[type] === "manufacturer" ? (
                              <img
                                // onError={(event) => (event.target.src = sq)}
                                width="24"
                                height="24"
                                src={
                                  types[type] === "seller"
                                    ? sellerImage
                                    : brandImage
                                }
                                alt=""
                              />
                            ) : (
                              // <svg
                              //   width="20px"
                              //   height="20px"
                              //   viewBox="0 0 22 22"
                              //   role="img"
                              //   xmlns="http://www.w3.org/2000/svg"
                              //   aria-labelledby="historyIconTitle"
                              //   stroke="#000000"
                              //   stroke-width="1"
                              //   stroke-linecap="square"
                              //   stroke-linejoin="miter"
                              //   fill="none"
                              //   color="#000000"
                              // >
                              //   {" "}
                              //   <title id="historyIconTitle">
                              //     History
                              //   </title>{" "}
                              //   <polyline points="1 12 3 14 5 12" />{" "}
                              //   <polyline points="12 7 12 12 15 15" />{" "}
                              //   <path d="M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,11.975305 3,12.3086383 3,13" />{" "}
                              // </svg>
                              <BsSearch />
                            )}
                          </span>
                          <span className=" w-full align-middle items-start  justify-center ml-1 leading-4 ">
                            <span
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(value),
                              }}
                            ></span>
                            <span className="text-dgrey1 font-light  ">
                              {" "}
                              {num_prods}
                            </span>{" "}
                          </span>
                        </span>

                        <span className="text-dgrey1 space-y-0 font-light text-right ml-1 my-2 ">
                          {" "}
                          {types[type]}{" "}
                        </span>
                      </Link>
                    ))}{" "}
              </div>
            ) : (
              <span className="text-dgrey1 space-y-0 font-light text-right m-2">
                {message}
              </span>
            )}
          </div>
        )}

        <input
          id="searchInput"
          type="text"
          className={`hidden placeholder-dlabelColor lg:block text-base rounded w-full h-9 hover:outline-none p-3 font-light focus:outline-none ${
            viewResults &&
            results?.length > 0 &&
            "rounded-br-none rounded-bl-none"
          }`}
          placeholder="What are you looking for? "
          value={query}
          onChange={(e) => {
            const value = e.target.value;
            const cleanedValue = value.replace(/\s{2,}/g, " ");
            if (cleanedValue !== "" || value === "") {
              setQuery(cleanedValue);
            }
          }}
          onKeyDown={(e) => {
            navigateSearch(e);
            handleOverlay(e);
          }}
          ref={wrapperRef}
          onClick={() => {
            setOverlay(true);
            handleSearchResults();
          }}
        />

        <div className="relative">
          {/* Search Bar - Always Rendered */}
          <input
            type="text"
            placeholder="What are you looking for?"
            value={query}
            onClick={() => setShowSearch(true)}
            className="block w-full  border border-dlabelColor   pl-2 pr-8  py-[0.25rem] rounded-md xl:hidden lg:hidden " // Add padding to the left to make space for the icon
          />

          {/* Search Icon */}
          <div className="absolute  top-0 right-0 h-full flex items-center pr-3 pointer-events-none md:hidden ">
            <FaSearch className="text-dlabelColor" />
          </div>
        </div>

        {/* Loading */}
        {loading && (
          <div className=" absolute right-4 top-1">
            <Loader styles="h-6 w-6 text-dgrey1" />
          </div>
        )}
        {/* Results */}
        {results.length > 0 && viewResults && (
          <div
            onMouseLeave={() => {
              // setViewResults(false);
              // setOverlay(false);
            }}
            onClick={() => setOverlay(false)}
            className="hidden xl:block lg:block absolute top-8  border-2 border-dgrey border-t-0 z-50 bg-white w-full text-dblack rounded rounded-tl-none rounded-tr-none"
          >
            {results.length > 0 &&
              results.slice(0, 8).map(({ type, id, value, img, num_prods }) => (
                <Link
                  key={Math.random()}
                  className="px-4 py-2 cursor-pointer hover:bg-dgrey flex items-center "
                  to={
                    isNaN(type)
                      ? //? "search?keyword=" + value
                        `${path}/search?keyword=${value}`
                      : // state.admin
                        // ? `${path}/${types[type]}/${id}`
                        // :
                        `${path}/${value
                          .replaceAll("/", "-")
                          .replaceAll("%", parseInt("%"))
                          .replaceAll("%20", "-")}/${types[type]?.slice(
                          0,
                          1
                        )}=${id}`
                  }
                >
                  <span className="flex w-full items-center align-middle  h-auto my-2 px-1 ">
                    <span class="w-12 ">
                      {img.length > 0 ? (
                        <img
                          onError={(event) => (event.target.src = sq)}
                          width="24"
                          height="24"
                          src={`${img}`}
                          alt=""
                        />
                      ) : types[type] === "seller" ||
                        types[type] === "manufacturer" ? (
                        <img
                          // onError={(event) => (event.target.src = sq)}
                          width="24"
                          height="24"
                          src={
                            types[type] === "seller" ? sellerImage : brandImage
                          }
                          alt=""
                        />
                      ) : (
                        // <svg
                        //   width="20px"
                        //   height="20px"
                        //   viewBox="0 0 22 22"
                        //   role="img"
                        //   xmlns="http://www.w3.org/2000/svg"
                        //   aria-labelledby="historyIconTitle"
                        //   stroke="#000000"
                        //   stroke-width="1"
                        //   stroke-linecap="square"
                        //   stroke-linejoin="miter"
                        //   fill="none"
                        //   color="#000000"
                        // >
                        //   {" "}
                        //   <title id="historyIconTitle">History</title>{" "}
                        //   <polyline points="1 12 3 14 5 12" />{" "}
                        //   <polyline points="12 7 12 12 15 15" />{" "}
                        //   <path d="M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,11.975305 3,12.3086383 3,13" />{" "}
                        // </svg>
                        <BsSearch />
                      )}
                    </span>
                    <span className=" w-full align-middle items-center justify-center ml-1 leading-4">
                      <span
                        className=""
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(value),
                        }}
                      ></span>
                      <span className="text-dgrey1 font-light">
                        {" "}
                        {num_prods}
                      </span>{" "}
                    </span>
                  </span>
                  <span className="text-dgrey1 text-left  capitalize text-sm">
                    {types[type]}
                  </span>
                </Link>
              ))}
          </div>
        )}
      </div>
    </>
  );
}

export default TopSearch;
